import { z } from "zod"

const currencyString = z
  .string()
  .optional()
  .refine(
    (val) => {
      if (!val || val === "") return true

      const numericValue = parseFloat(val)
      return !isNaN(numericValue) && numericValue >= 0
    },
    {
      message: "Please enter a valid currency amount",
    }
  )

export const paymentTermsFormSchema = z.object({
  companyId: z.string(),
  creditLimitCustomer: currencyString,
  paymentTermIdCustomer: z.string().optional(),
  creditLimitVendor: currencyString,
  paymentTermIdVendor: z.string().optional(),
  sensitiveAccount: z.boolean().nullable().optional(),
  defaultExpenseAccountId: z.string().nullable().optional(),
})

export type PaymentTermsFormValues = z.infer<typeof paymentTermsFormSchema>
